<script>
import HsSectionCard from "@/base/hs-tableview/hs-section/hs-section-card.vue";
import HsFormCell from "@/base/hs-tableview/hs-section/hs-form-cell.vue";
import HsTeleport from "@/base/hs-teleport/hs-teleport.vue";
import HsNation from "@/base/hs-nation/hs-nation.vue";
import HsTag from "@/base/hs-tag/hs-tag.vue";
import HsFormCellDes from "@/base/hs-tableview/hs-section/hs-form-cell-des.vue";
import {getMarkClassName} from "@/pages/personal/passengers/passenger-details/details";
import {getIsBabySmallFourteen, getPassengerType} from "@/common/utility/utils";

export default {
  props: {
    currentDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    details: {
      type: Object,
      default: () => {
        return {}
      }
    },
    XOrder: {
      type: Object,
      default: () => {
        return {}
      }
    },
    powerDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    credential: {
      type: Object,
      default: () => {
        return {}
      }
    },
    OrderBusinessType: {
      type: Number,
      default: 0
    },
    submitChecked: {
      type: Boolean,
      default: false
    },
    credentialList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      showDatePicker: false, // 证件有效期选择器
      currentDatePickerValue: '', // 当前的日期选择器上显示的证件有效期
      selectNationCode: ''
    }
  },
  computed: {
    IsAdd () {
      return !(this.currentDetails.index >= 0)
    },
    IsEnableBusinessEdit() {
      if (
          Number(this.currentDetails.TravelType) === 1 ||
          this.hasPower('我的:常旅客管理:因公编辑')
      ) {
        return true
      } else {
        return this.IsAdd
      }
    },
    isRightCredential() {
      if (this.credential.CredentialType === 1) {
        let val = this.credential.CredentialNo
        if (this.idCard(val).valid) {
          return true
        } else {
          return false
        }
      } else {
        let list = this.OrderBusinessType === 0 ? this.credentialList : this.currentDetails.Credentials
        let sel = list ? list.find(m => m.CredentialType === 1) : null
        let val = sel ? sel.CredentialNo : ''
        if (this.idCard(val).valid) {
          return true
        } else {
          return false
        }
      }
    },
    NationSetting() {
      let Required = this.powerDetails.requiredNation
      let Edit = true;
      let Show = this.powerDetails.showNation;
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked && Show && Required && (!this.currentDetails.Nation || !this.currentDetails.Nation.Name)) {
        IsShowError = true
      }
      return {
        Show: Show,
        Name: this.$t('Nation'),
        ClassName: getMarkClassName('Nation'),
        Required: Required,
        Type: 'disabled-input',
        Edit: Edit,
        Placeholder: Edit ? this.$getPlaceholder(1, false) : this.$t('Unmodifiable'),
        ShowLogo: Edit,
        ErrTips: ErrTips,
        IsShowError: IsShowError
      }
    },
    BirthdaySetting() {
      let Show = this.powerDetails.showBirthday;
      let Required = this.powerDetails.requiredBirthday
      let Edit = this.IsEnableBusinessEdit
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked && Show && Required && !this.currentDetails.Birthday) {
        IsShowError = true
      }
      return {
        Show: Show,
        Name: this.$t('DateOfBirth'),
        ClassName: getMarkClassName('DateOfBirth'),
        Required: Required,
        Type: 'disabled-input',
        Edit: Edit,
        Placeholder: Edit ? this.$getPlaceholder(1, false) : this.$t('Unmodifiable'),
        ShowLogo: Edit,
        IsShowError: IsShowError,
        ErrTips: ErrTips
      }
    },
    GenderSetting() {
      let Required = this.powerDetails.requiredGender
      let Edit = this.IsEnableBusinessEdit
      let Show = this.powerDetails.showGender;
      let IsShowError = false
      let ErrTips = ''
      let NewGender = Number(this.currentDetails.NewGender)
      if (this.submitChecked && Show && Required && NewGender !== 1 && NewGender !== 2) {
        IsShowError = true
        ErrTips = this.$t('PleaseSelect_x', 'function', [this.$t('Gender')])
      }
      return {
        Show: Show,
        Name: this.$t('Gender'),
        ClassName: getMarkClassName('Gender'),
        Required: Required,
        Type: 'disabled-input',
        Edit: Edit,
        Placeholder: Edit ? this.$getPlaceholder(1, Required) : this.$t('Unmodifiable'),
        IsShowError,
        ErrTips
      }
    },
    MobileSetting() {
      let Required = this.powerDetails.requiredMobile
      let Edit = this.IsEnableBusinessEdit
      let Show = true;
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked && !this.currentDetails.Mobile) {
        IsShowError = true
      }
      if (this.currentDetails.Mobile && !this.isPhoneNumber(this.currentDetails.Mobile, this.currentDetails.MobileCountryCode)) {
        IsShowError = true
        ErrTips = this.$t('PhoneNumberFormatIsIncorrect')
      }
      return {
        Show: Show,
        Name: this.$t('CellphoneNumber'),
        ClassName: getMarkClassName('CellphoneNumber'),
        Required: Required,
        Type: 'input',
        Edit: Edit,
        IsEnableDesensitize: this.getSetting("常用配置:用户隐私"),
        Placeholder: Edit ? this.$getPlaceholder(0, false) : this.$t('Unmodifiable'),
        IsShowError,
        ErrTips
      }
    },
    EmailSetting() {
      let Required = this.currentDetails.IsSendBookEmail || this.currentDetails.IsSendIssuedEmail || this.currentDetails.IsSendConfirmEmail
      let Edit = this.IsEnableBusinessEdit
      let Show = true;
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked && Required && !this.currentDetails.Email) {
        IsShowError = true
      }
      if (this.currentDetails.Email && !this.isEmail(this.currentDetails.Email)) {
        IsShowError = true
        ErrTips = this.$t('EmailFormatIsIncorrect')
      }
      return {
        Show: Show,
        Name: this.$t('Email'),
        ClassName: getMarkClassName('Email'),
        Required: Required,
        Type: 'input',
        Edit: Edit,
        IsEnableDesensitize: this.getSetting("常用配置:用户隐私"),
        Placeholder: Edit ? this.$getPlaceholder(0, false) : this.$t('Unmodifiable'),
        IsShowError,
        ErrTips
      }
    },

    // 证件有效期最小值
    datePickerMinDate() {
      // 获取当前时间
      let currentDate = new Date();
      // 获取当前年份
      let currentYear = currentDate.getFullYear();
      // 将当前年份减去100
      let futureYear = currentYear - 100;
      // 设置 Date 对象的年份为100年前的年份
      currentDate.setFullYear(futureYear);
      return currentDate;
    },
    // 证件有效期最大值
    datePickerMaxDate() {
      return new Date()
    }
  },
  watch: {
    isRightCredential(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        let val = ''
        if (this.credential.CredentialType === 1) {
          val = this.credential.CredentialNo
        } else {
          let list = this.OrderBusinessType === 0 ? this.credentialList : this.currentDetails.Credentials
          let sel = list ? list.find(m => m.CredentialType === 1) : null
          val = sel ? sel.CredentialNo : ''
        }
        this.$emit("updateGenBirNatWithCardNo", val);
      }
    }
  },
  methods: {
    _openSelectNation() {
      if (!this.NationSetting.Edit) {
        return
      }
      let v = this.currentDetails.Nation
      this.selectNationCode = v && v.Code
      this.$refs.HsNation && this.$refs.HsNation.open()
    },

    _setNation(item) {
      let Nation = {
        ID: item.Id,
        Name: this.getNationName(item),
        Code: item.NationDistCode,
        ThreeCharCode: item.NationCode
      }
      this.currentDetails.Nation = {...Nation}
      this.$emit('update:currentDetails', this.currentDetails)
    },

    /** 打开证件有效期选择框 */
    _openBirthdayDatePicker() {
      // 设置当前值
      if (this.currentDetails.Birthday && this.currentDetails.Birthday !== '1900-01-01') {
        this.currentDatePickerValue = this.NewDate(this.currentDetails.Birthday);
      } else {
        this.currentDatePickerValue = this.NewDate(this.getNewDate(this.beTime(new Date()), -30, 0, 0));
      }
      this.showDatePicker = true;
    },

    // 出生日期
    _confirmDatePicker() {
      this.currentDetails.Birthday = this.beTime(Date.parse(this.currentDatePickerValue))
      this.$emit('update:currentDetails', this.currentDetails)
      this.showDatePicker = false;
    },

    // 设置性别
    _setGenter(val) {
      if (!this.GenderSetting.Edit) {
        this.$toast(this.$t('Unmodifiable'))
        return
      }
      this.currentDetails.NewGender = val
      this.$emit('update:currentDetails', this.currentDetails)
    },

    // 手机国家代码
    _openMobileCountryCode() {
      if (!this.MobileSetting.Edit) {
        this.$toast(this.$t('Unmodifiable'))
        return
      }
      this.$refs.refMobileCountryCode && this.$refs.refMobileCountryCode.open()
    },

    // 设置手机国家代码
    _setMobileCountryCode(item) {
      this.currentDetails.MobileCountryCode = item.Code
      this.$emit('update:currentDetails', this.currentDetails)
    },

    localCheck() {
      // 国籍
      if (this.NationSetting.Show && this.NationSetting.IsShowError) {
        this.$toast(this.$t('PleaseSelect_x', 'function', [this.NationSetting.Name]))
        return this.NationSetting.ClassName
      }
      // 出生日期
      if (this.BirthdaySetting.Show && this.BirthdaySetting.IsShowError) {
        this.$toast(this.$t('PleaseSelect_x', 'function', [this.BirthdaySetting.Name]))
        return this.BirthdaySetting.ClassName
      }

      // 国内机票小于14天的婴儿不允许添加
      if (this.OrderBusinessType === 1) {
        let {SelectedFlights = []} = this.XOrder
        let len = SelectedFlights.length
        let FlightDetails = SelectedFlights[len - 1] ? SelectedFlights[len - 1].FlightDetails : {}
        let lastSegmentTakeOffTime = FlightDetails && FlightDetails.DepartDateTime ? this.beTime(FlightDetails.DepartDateTime, 'yyyy-MM-dd') : '' // 最后一程起飞时间
        this.currentDetails.PassengerType = getPassengerType(this.currentDetails.Birthday, lastSegmentTakeOffTime)
        this.currentDetails.isSmallFourteen = getIsBabySmallFourteen(this.currentDetails.Birthday, lastSegmentTakeOffTime)
        if (this.currentDetails.isSmallFourteen) { // 小与14天的婴儿 禁止添加
          this.$alert({
            type: 'new',
            content: this.$t('BabyTooSmallNonBookable'),
            confirmFn: () => {}
          })
          return this.BirthdaySetting.ClassName
        }
      }

      // 性别
      if (this.GenderSetting.Show && this.GenderSetting.IsShowError) {
        this.$toast(this.$t('PleaseSelect_x', 'function', [this.$t('Gender')]))
        return this.GenderSetting.ClassName
      }
      // 手机号
      if (this.MobileSetting.Show && this.MobileSetting.IsShowError) {
        this.$toast(this.MobileSetting.ErrTips || this.$t('PleaseFill_x', 'function', [this.MobileSetting.Name]))
        return this.MobileSetting.ClassName
      }
      // 邮箱
      if (this.EmailSetting.Show && this.EmailSetting.IsShowError) {
        this.$toast(this.EmailSetting.ErrTips || this.$t('PleaseFill_x', 'function', [this.EmailSetting.Name]))
        return this.EmailSetting.ClassName
      }
    }
  },
  components: {
    HsFormCellDes,
    HsTag,
    HsNation,
    HsTeleport,
    HsFormCell,
    HsSectionCard
  }
}
</script>

<template>
  <hs-section-card :title="$t('OtherInformation')">
    <div class="details">
      <!--国籍-->
      <hs-form-cell
          v-if="NationSetting.Show"
          @click="_openSelectNation"
          :class="NationSetting.ClassName"
          :value="currentDetails.Nation ? currentDetails.Nation.Name : ''"
          :title="NationSetting.Name"
          :type="NationSetting.Type"
          :placeholder="NationSetting.Placeholder"
          :edit="NationSetting.Edit"
          :showLogo="NationSetting.ShowLogo"
          :errTips="NationSetting.ErrTips"
          :required="NationSetting.Required"
          :is-show-error="NationSetting.IsShowError"
      />
      <!--出生日期-->
      <hs-form-cell
          v-if="BirthdaySetting.Show"
          :class="BirthdaySetting.ClassName"
          @click="_openBirthdayDatePicker"
          :value="currentDetails.Birthday"
          :title="BirthdaySetting.Name"
          :type="BirthdaySetting.Type"
          :placeholder="BirthdaySetting.Placeholder"
          :edit="BirthdaySetting.Edit"
          :showLogo="BirthdaySetting.ShowLogo"
          :errTips="BirthdaySetting.ErrTips"
          :required="BirthdaySetting.Required"
          :is-show-error="BirthdaySetting.IsShowError"
      />
      <!--性别-->
      <hs-form-cell
        v-if="GenderSetting.Show"
        :class="GenderSetting.ClassName"
        :title="GenderSetting.Name"
        :edit="GenderSetting.Edit"
        :required="GenderSetting.Required"
        :show-separator="false"
      >
        <hs-tag class="hs-tag" :class="{unEdit: !GenderSetting.Edit}" type="white" :title="$t('Male')" :active="currentDetails.NewGender === 1" @click.native="_setGenter(1)" />
        <hs-tag class="hs-tag" :class="{unEdit: !GenderSetting.Edit}" type="white" :title="$t('Female')" :active="currentDetails.NewGender === 2" @click.native="_setGenter(2)" />
      </hs-form-cell>
      <!--手机号-->
      <hs-form-cell-des
          v-if="MobileSetting.Show"
          :class="MobileSetting.ClassName"
          v-model="currentDetails.Mobile"
          :title="MobileSetting.Name"
          :type="MobileSetting.Type"
          :placeholder="MobileSetting.Placeholder"
          :edit="MobileSetting.Edit"
          telFunName="telDes"
          :IsEnableDesensitize="MobileSetting.IsEnableDesensitize"
          :errTips="MobileSetting.ErrTips"
          :required="MobileSetting.Required"
          :is-show-error="MobileSetting.IsShowError"
          clearable
      >
        <div class="valuePrefix" :class="{gray: !MobileSetting.Edit}" slot="valuePrefix" @click="_openMobileCountryCode">
          <span>{{currentDetails.MobileCountryCode}}</span>
          <span class="icon-arrow"></span>
          <div class="line"></div>
        </div>
      </hs-form-cell-des>
      <!--邮箱-->
      <hs-form-cell-des
          v-if="EmailSetting.Show"
          :class="EmailSetting.ClassName"
          v-model="currentDetails.Email"
          :title="EmailSetting.Name"
          :type="EmailSetting.Type"
          :placeholder="EmailSetting.Placeholder"
          :edit="EmailSetting.Edit"
          telFunName="emailDes"
          :IsEnableDesensitize="EmailSetting.IsEnableDesensitize"
          :errTips="EmailSetting.ErrTips"
          :required="EmailSetting.Required"
          :is-show-error="EmailSetting.IsShowError"
          clearable
      />
      <hs-teleport to="body">
        <!-- 国籍 -->
        <hs-nation ref="HsNation" @select="_setNation" :NationCode="selectNationCode" />

        <!-- 证件有效期 -->
        <van-popup v-model="showDatePicker" position="bottom" round safe-area-inset-bottom>
          <van-datetime-picker
              class="hs-date-picker"
              v-model="currentDatePickerValue"
              type="date"
              :title="$t('DateOfBirth')"
              :confirm-button-text="$t('Confirm')"
              :cancel-button-text="$t('Cancel')"
              :min-date="datePickerMinDate"
              :max-date="datePickerMaxDate"
              @confirm="_confirmDatePicker"
              @cancel="showDatePicker = false"
          />
        </van-popup>

        <!--手机国家代码-->
        <hs-nation ref="refMobileCountryCode" @select="_setMobileCountryCode" type="mobileCountryCode" :NationCode="currentDetails.MobileCountryCode" />
      </hs-teleport>
    </div>
  </hs-section-card>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-tag{
  margin-bottom: 0;
  margin-left: 16px;
  &.unEdit{
    opacity: .6;
  }
  &:first-child{
    margin-left: 0;
  }
}
.valuePrefix{
  @extend .flex-start;
  padding-right: 12px;
  flex-shrink: 0;
  &.gray{
    >span:first-child{
      color: $color_black_100;
    }
  }
  span{
    flex-shrink: 0;
  }
  >span:first-child{
    @extend .hs-font-subtitle-big;
    color: $color_black_800;
    margin-right: 8px;
  }
  >.icon-arrow{
    width: 12px;
    height: 12px;
    margin-left: 8px;
    background-image: url('@/assets/image/base/cell/icons_16pt_more.png');
    background-size: 100% 100%;
    transform: rotate(90deg);
  }
  >.line{
    width: 1px;
    height: 16px;
    background-color: $color_black_40;
    margin-left: 12px;
  }
}
.hs-date-picker{
  :deep(.van-picker__toolbar){
    height: 48px;
  }
  :deep(.van-picker__confirm) {
    color: $color_theme_300;
  }
}
</style>
